const _raf  = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window['mozRequestAnimationFrame'] ||
        window['msRequestAnimationFrame'] ||
        window['oRequestAnimationFrame'] ||   //火狐老版本
        function (callback) {    //IE9以及以下版本
            window.setTimeout(callback, 1000 / 60);  //这里强制让动画一秒刷新60次，这里之所以设置为16.7毫秒刷新一次，是因为requestAnimationFrame默认也是16.7毫秒刷新一次。
        }
})();
export const requestAnimationFrameX=_raf.bind(window); 




// WEBPACK FOOTER //
// ./src/utils/requestAnimationFrame.ts